import { IsMcsPageResult, getProductFilteringAsQueryString } from '../Actions/ProductFiltering.action';
import {
  PRODUCT_FILTERING_RECEIVE,
  PRODUCT_LISTING_SET_PRODUCTS,
} from '../constants';

export const historyMiddleware = ({ dispatch, getState }) => (next) => (action) => {
  if (typeof action === 'function') {
    // then call the function and pass `dispatch` and `getState` as arguments
    return action(dispatch, getState)
  }
  const { type, payload } = action;
  switch (type) {
    case PRODUCT_FILTERING_RECEIVE:
      const queryString = getProductFilteringAsQueryString(payload);
      const isMcsPage = dispatch(IsMcsPageResult(payload));
      if(!isMcsPage && !action.isInitialLoad){
        const url =
          window.location.href.replace(window.location.search, '') +
          `${queryString ? '?' : ''}${queryString}`;
        window.history.pushState('search', 'Search Page', url);
      }
      break;
    case PRODUCT_LISTING_SET_PRODUCTS:
      setProductsCount(payload?.products);
      break;
  }
  return next(action);
};

const setProductsCount = (products) => {
  const query = new URLSearchParams(window.location.search);
  if (products?.length > 0) {
    query.set('count', products.length);
  } else {
    query.delete('count');
  }
  const url =
    window.location.href.replace(window.location.search, '') +
    `?${query.toString()}`;
  window.history.pushState('setProductsCount', null, url);
};
